import { forwardRef, createElement, ComponentProps } from 'react'

import { Grid as GridBase, styled, GridProps, gridClasses } from '@mui/material'

const StyledContainer = styled(GridBase, {
  shouldForwardProp: (prop: string) => !['spacingX', 'spacingY'].includes(prop),
})<{ spacingX: GridProps['spacing']; spacingY: GridProps['spacing'] }>(({ theme, spacingX = 3, spacingY = 3 }) => {
  return {
    margin: 0,
    width: '100%',
    marginTop: 12 - ((spacingY as number) * 8) / 2,

    [`& > .${gridClasses.root}`]: {
      paddingTop: theme.spacing((spacingY as number) / 2),
      paddingBottom: theme.spacing((spacingY as number) / 2),
      paddingRight: theme.spacing((spacingX as number) / 2),
      paddingLeft: theme.spacing((spacingX as number) / 2),
    },
  }
})

type ContainerProps = ComponentProps<typeof GridBase> & {
  spacingX: GridProps['spacing']
  spacingY: GridProps['spacing']
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(function Container(props, ref) {
  const { container = true, ...rest } = props

  return createElement(StyledContainer, { ref, container, ...rest })
})
